import type { LeadtimeConditionSummary } from 'lumen/models/recommendation-strategy';
import { PRICE_RANGE_STRATEGY_CONDITION_OPERATORS as OPERATOR } from 'lumen/utils/constants/pricing-assistant-constants';

const OPEN_BAND_OPERATOR_SYMBOLS: Record<string, string> = {
  [OPERATOR.GT]: '>',
  [OPERATOR.GTE]: '≥',
  [OPERATOR.LT]: '<',
  [OPERATOR.LTE]: '≤',
};

/* Build the human-readable band label from a lead time condition summary.
 * A bounded band (both bounds present) renders as "low - high"; a band
 * open on one side renders with the symbol matching that side's operator
 * (e.g. "> 7" for GT, "≥ 7" for GTE, "< 3" for LT, "≤ 3" for LTE).
 */
export function formatLeadtimeConditionLabel(
  summary: LeadtimeConditionSummary,
): string {
  const { lowerBound, upperBound } = summary;

  if (lowerBound && upperBound) {
    return `${lowerBound.value} - ${upperBound.value}`;
  }

  const bound = lowerBound ?? upperBound;

  if (!bound) {
    return '';
  }

  const symbol = OPEN_BAND_OPERATOR_SYMBOLS[bound.operation] ?? '>';

  return `${symbol} ${bound.value}`;
}
